module.exports = __webpack_public_path__ + "static/media/Giratina_gaussian2.f3ff7a08.png";